import {BijbEvent} from '../../models/bijb-event';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class BijbEventState extends LoadableState {
  public static readonly key = 'BijbEventState';

  @autoserializeAs(BijbEvent, 'bijb-event')
  public bijbEvent: BijbEvent = null;

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
